var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 16C37.408 16 16 37.408 16 64V176H496V64C496 37.408 474.592 16 448 16H64Z",
    fill: "#C0392B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 336V448C16 474.592 37.408 496 64 496H448C474.592 496 496 474.592 496 448V336H16Z",
    fill: "#27AE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 141V371H496V141H16Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M237.119 199.618C229.714 199.618 222.383 201.076 215.542 203.91C208.701 206.743 202.485 210.896 197.25 216.132C192.014 221.368 187.861 227.583 185.028 234.424C182.194 241.265 180.736 248.597 180.736 256.001C180.736 270.954 186.677 285.295 197.251 295.869C207.824 306.442 222.165 312.382 237.119 312.382C245.567 312.372 253.904 310.463 261.515 306.798C269.126 303.132 275.817 297.803 281.091 291.204C272.333 299.193 260.912 303.63 249.058 303.649C236.421 303.65 224.301 298.63 215.365 289.694C206.429 280.758 201.408 268.638 201.408 256.001C201.408 249.743 202.64 243.547 205.035 237.766C207.429 231.985 210.939 226.732 215.364 222.307C219.789 217.882 225.042 214.372 230.823 211.978C236.604 209.583 242.801 208.351 249.058 208.351C261.03 208.373 272.556 212.901 281.341 221.034C276.064 214.359 269.344 208.964 261.686 205.255C254.027 201.547 245.628 199.619 237.119 199.618V199.618Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M327.681 273.906L306.338 267.709L292.768 285.848L292.065 263.635L270.622 256.334L291.53 248.802L291.847 226.151L305.472 243.709L327.112 237.011L314.623 255.395L327.681 273.906Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLy);
export default __webpack_public_path__ + "static/media/LY.434e363f0077ae34f95007c2f0f41a8e.svg";
export { ForwardRef as ReactComponent };